import React from 'react';

// Material
import { Typography } from '@mui/material';
import { PasswordField } from 'commons/components/PasswordField/PasswordField';
import ButtonWithLoader from 'commons/containers/ButtonWithLoader/ButtonWithLoader';
import { useForm } from 'utils/hooks/useForm';
import { VALIDATIONS } from 'utils/validations';
// Project
import AuthLayout, { AUTH_FONTS } from 'modules/main/Login2/components/AuthLayout';

function NewPasswordForm({ controls, actions, onSubmit }) {
  const {
    onChange,
    onSubmit: onFormSubmit,
    errors,
  } = useForm(controls, actions, {
    bailByDefault: true,
    prettyErrors: true,
    validations: {
      password: [VALIDATIONS.SIGNUP_PASSWORD],
      passwordConfirmation: [
        VALIDATIONS.SIGNUP_PASSWORD,
        { check: (value) => value === controls.password, message: 'Debe ser igual a contraseña' },
      ],
    },
  });

  function onClickSubmit() {
    onFormSubmit(() => onSubmit());
  }

  const fieldProps = {
    fullWidth: true,
    variant: 'outlined',
    InputProps: { sx: { fontSize: AUTH_FONTS.field } },
    InputLabelProps: { sx: { fontSize: AUTH_FONTS.field } },
    FormHelperTextProps: { sx: { fontSize: AUTH_FONTS.helper } },
  };

  return (
    <AuthLayout title="Nueva contraseña" subtitle="Crea una contraseña para tu cuenta.">
      <PasswordField
        {...fieldProps}
        error={!!errors.password}
        label="Contraseña"
        helperText={errors.password ?? 'Mínimo 6 carácteres, 1 mayúscula, 1 minúscula y 1 número'}
        id="password"
        value={controls.password}
        onChange={onChange}
      />
      <PasswordField
        {...fieldProps}
        error={!!errors.passwordConfirmation}
        helperText={errors.passwordConfirmation}
        label="Confirmar contraseña"
        id="passwordConfirmation"
        value={controls.passwordConfirmation}
        onChange={onChange}
      />

      {controls.error ? (
        <Typography sx={{ color: '#e11', fontSize: AUTH_FONTS.link, textAlign: 'center' }}>
          {controls.error}
        </Typography>
      ) : null}

      <ButtonWithLoader
        buttonId="new-password"
        ButtonProps={{
          variant: 'contained',
          color: 'primary',
          onClick: onClickSubmit,
          fullWidth: true,
          size: 'large',
          sx: { mt: 1, textTransform: 'none', borderRadius: 2, fontSize: AUTH_FONTS.button },
        }}>
        Guardar
      </ButtonWithLoader>
    </AuthLayout>
  );
}

export default NewPasswordForm;
